import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TooltipTextCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';

import { joinOrDash } from './deliveryAgencyTableCells';

import type { CollectingOutboundListItem } from '~/types/delivery-agency.types';

const getDeliveryAgencyCollectingRequestCandidatesColumnDefs = ({
  currentPage,
  pageSize,
}: {
  currentPage: number;
  pageSize: number;
}) => {
  const columnDefs: TypeTableColumn<CollectingOutboundListItem>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 49,
      meta: { selection: true },
    },
    {
      id: 'rowNumber',
      header: 'No',
      cell: ({ row }) => row.index + 1 + currentPage * pageSize,
      size: 72,
    },
    {
      accessorKey: 'outboundCode',
      header: '출고번호',
      size: 160,
    },
    {
      accessorKey: 'clientOrderCodes',
      header: '판매처 주문번호(원주문)',
      size: 160,
      cell: ({ row }) => <TooltipTextCell valueFormatted={joinOrDash(row.original.clientOrderCodes)} />,
    },
    {
      accessorKey: 'receiverName',
      header: '원주문 수령자명',
      size: 120,
    },
    {
      accessorKey: 'ordererName',
      header: '원주문 주문자명',
      size: 120,
    },
    {
      accessorKey: 'productNames',
      header: '원주문 상품명',
      size: 248,
      cell: ({ row }) => <TooltipTextCell valueFormatted={joinOrDash(row.original.productNames)} />,
    },
    {
      accessorKey: 'estimatedDeliveryDate',
      header: '배송예정일',
      size: 164,
      cell: ({ row }) => formatDate(row.original.estimatedDeliveryDate, DATE_FORMAT.DATE) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCollectingRequestCandidatesColumnDefs;
